<template>
    <main class="page page-dashboard">
        <div class="container">

            <PageHeader
                :title="$translate.text('clients.connections.pricing.add')"
            />

            <ConnectionMenu></ConnectionMenu>

            <div v-if="disablePricing">
                <Alert>{{ t('alert.pricing.not.needed') }}</Alert>
            </div>
            <div v-else>

                <form @submit.prevent="submitForm" method="POST">
                    <h4>{{ t('clients.connections.general') }}</h4>

                    <Select
                        id="brands"
                        :value="pricing.brand_id"
                        name="brands"
                        @change="pricing.brand_id = ($event === '' ? null : parseInt($event,10))"
                        :options="brandsSelectValues"
                        :label="$translate.text('clients.connections.pricing.brand')"
                        :required="false"
                        :loading="!brandsLoaded || !connectionLoaded"
                    />

<!--                    <Select-->
<!--                        id="categories"-->
<!--                        :value="pricing.category_id"-->
<!--                        name="categories"-->
<!--                        @change="pricing.category_id = ($event === '' ? null : parseInt($event,10))"-->
<!--                        :options="categoriesSelectValues"-->
<!--                        :label="$translate.text('clients.connections.pricing.category')"-->
<!--                        :required="false"-->
<!--                        :loading="!categoriesLoaded || !connectionLoaded"-->
<!--                    />-->

                    <div class="form-group">
                        <label for="categories">{{ $translate.text('general.categories') }}
                            <i style="font-size: 14px;"></i>
                        </label>

                        <Multiselect
                            v-model="pricing.categories"
                            :options="categoriesSelectValues"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            :placeholder="this.$translate.text('general.select_all')"
                            label="label"
                            track-by="value"
                            open-direction="bottom"
                            id="categories"
                        >
                            <!-- <template slot="selection" open-direction="bottom" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> -->
                        </Multiselect>
                    </div>

                    <NumberInput
                        id="min"
                        :value="pricing.min"
                        name="min"
                        @change="pricing.min= parseInt($event, 10)"
                        :label="$translate.text('clients.connections.pricing.min')"
                    />

                    <NumberInput
                        id="max"
                        :value="pricing.max"
                        name="max"
                        @change="pricing.max= parseInt($event, 10)"
                        :label="$translate.text('clients.connections.pricing.max')"
                    />

                    <NumberInput
                        id="marge"
                        :value="pricing.marge"
                        name="marge"
                        @change="pricing.marge= parseInt($event, 10)"
                        :label="$translate.text('clients.connections.pricing.marge')"
                        :required="true"
                    />

                    <FormSubmit
                        :routeAfterCancelLink="{ name: 'Clients Connections Pricing' }"
                        :buttonLabel="submittingIsLoading ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                        :disabled="submittingIsLoading"
                    />
                </form>
            </div>
        </div>
    </main>
</template>
<script>
import Multiselect from 'vue-multiselect';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import NumberInput from '@/components/Inputs/NumberInput';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';


import Alert from '@/components/Alert/Alert';

export default {
    name: 'ClientAddPricing',

    components: {
        ConnectionMenu,
        PageHeader,
        NumberInput,
        Select,
        FormSubmit,
        Alert,
        Multiselect,
    },

    data() {
        return {
            pricing: {
                brand_id: null,
                category_id: null,
                categories: [],
                min: null,
                max: null,
                marge: null,
            },

            disablePricing: false,

            connection: null,
            connectionLoaded: false,

            webshopcategories: [],
            webshopcategoriesLoaded: false,

            brands: [],
            brandsLoaded: false,

            categories: [],
            categoriesLoaded: false,

            submittingIsLoading: false,
        };
    },

    created() {
        this.getCombinedBrands();
        this.getCombinedCategories();
        this.getConnection();
    },

    methods: {
        getCombinedBrands() {
            this.API.clients.connections.brands.getCombined(this.$route.params.id)
                .then(response => {
                    this.brands = response.data.data;
                    this.brandsLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombinedCategories() {
            this.API.clients.connections.categories.getCombined(this.$route.params.id)
                .then(response => {
                    this.categories = response.data.data;
                    this.categoriesLoaded = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    this.connection = response.data.data;
                    this.connectionLoaded = true;

                    this.getCombined(this.connection.feed_id);
                    this.getWebshopCategories(this.connection.id);
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getWebshopCategories(connectionId) {
            if (this.connection.configbase === 'webshop') {
                this.API.clients.connections.categories.getItemsFromWebshop(connectionId)
                    .then(response => {
                        this.webshopcategories = response.data;
                        this.webshopcategoriesLoaded = true;
                    }).catch(error => {
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            } else {
                this.webshopcategoriesLoaded = true;
            }
        },

        getCombined(feedId) {
            this.API.clients.feeds.combine.combined(feedId)
                .then(response => {
                    if (response.data.data) {
                        const data = response.data.data;
                        if (data.purchase_price[0] === null) {
                            this.disablePricing = true;
                        }
                    }
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            this.submittingIsLoading = true;

            this.API.clients.connections.pricing.store(this.$route.params.id, this.pricing)
                .then(() => {
                    this.submittingIsLoading = false;
                    this.$router.push({ name: 'Clients Connections Pricing' });
                    this.resetForm();
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        resetForm() {
            this.pricing = {
                brand_id: null,
                category_id: null,
                min: null,
                max: null,
                marge: null,
            };
        },

        findCategoryNameById(categories, id, name = null) {
            categories.forEach(category => {
                if (category.id === id) {
                    name = category.name;
                }

                if (category.children) {
                    name = this.findCategoryNameById(category.children, id, name);
                }
            });

            return name;
        },
    },

    computed: {
        brandsSelectValues() {
            const values = [
                { label: this.$translate.text('general.select_all'), value: null },
                // { label: this.$translate.text('general.select_all'), value: 0 },
            ];

            this.brands.forEach(brand => {
                values.push({
                    value: brand.id,
                    label: brand.feed_name,
                });
            });

            return values;
        },

        categoriesSelectValues() {
            // const values = [
            //     { label: this.$translate.text('general.select_all'), value: null },
            // ];
            const values = [];

            if (this.connectionLoaded && this.webshopcategoriesLoaded) {
                this.categories.forEach(category => {
                    values.push({
                        value: category.id,
                        label: this.connection.configbase === 'feed' ? category.feed_name : this.findCategoryNameById(this.webshopcategories, category.webshop_id),
                    });
                });
            }

            return values;
        },
    },


};
</script>
<style lang="scss" scoped>
.form-group {
    display: flex;
    align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    .multiselect {
        -webkit-box-flex: 6;
        -ms-flex: 6;
        flex: 6;
        // height: 42px;
        font-size: 16px;
        border: 0;
        background-color: white;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        padding: 0px 16px;
    }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
